/** @jsx h */

import { h, Component } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import styles from './index.scss';

class ButtonResumeTs extends Component {
    render() {
        const { className, onClick, children } = this.props;
        return (
            <button onClick={onClick} className={`${styles.btn} ${className}`}>
                {children}
            </button>
        );
    }
}

ButtonResumeTs.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};

ButtonResumeTs.defaultProps = {
    className: '',
    onClick: () => {},
};

export default ButtonResumeTs;
